import React from "react";
import { connect } from "react-redux";
import { modelDataChanged } from "../../Redux/Actions/formsActions";

const generateInput = (col, props) => {
  const { data, onModelDataChanged } = props;
  const value = data[col.accessor] ? data[col.accessor] : "";

  switch (col.inputType) {
    case "textarea":
      return (
        <textarea
          id={col.accessor}
          className="form-control"
          required={!!col.required}
          value={value}
          onChange={e => onModelDataChanged(e.target.value, col.accessor)}
        />
      );
    case "checkbox":
    case "text":
      return (
        <input
          type={col.inputType}
          id={col.accessor}
          className="form-control"
          required={!!col.required}
          placeholder={col.placeholder}
          value={value}
          checked={!!value}
          autoComplete="off"
          onChange={e =>
            onModelDataChanged(
              e.target.type === "checkbox" ? e.target.checked : e.target.value,
              col.accessor
            )
          }
        />
      );
    case "select":
      return (
        <select
          name={col.accessor}
          id={col.accessor}
          className="form-control"
          required={!!col.required}
          value={value}
          onChange={e => onModelDataChanged(e.target.value, col.accessor)}
        >
          {col.options &&
            col.options.map(option => (
              <option key={option.key} value={option.key}>
                {option.value}
              </option>
            ))}
        </select>
      );
    default:
      return <div></div>;
  }
};

const LeftFormInputs = props => {
  const { columns } = props;

  return columns.map((group, index) => {
    return (
      <div key={index} className="row">
        {group.map(col => {
          return (
            <div key={col.accessor} className="col-md-12 form-group">
              <label className="col-md-4" htmlFor={col.accessor}>
                {col.Header}
              </label>
              <div className="col-md-8">{generateInput(col, props)}</div>
            </div>
          );
        })}
        {columns.length - 1 > index && <hr />}
      </div>
    );
  });
};

LeftFormInputs.defaultProps = {
  data: {}
};

const mapStateToProps = (state, ownProps) => ({
  data: state.forms[ownProps.model]
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onModelDataChanged: (data, field) =>
    dispatch(modelDataChanged(data, field, ownProps.model))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeftFormInputs);
